import projection from '../generated/pwn502f1.json';
import { AcceptanceManifest } from '../types';
export const pwn502f1AcceptanceManifest = projection as AcceptanceManifest;
